module.exports = __webpack_public_path__ + "img/2011.4a57a93b.png";